var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58315 3.0612C1.53469 3.5679 1.50068 4.46462 1.8059 4.84632C1.8059 4.84632 1.66222 3.86125 2.95028 2.62533C3.4689 2.1278 3.58878 1.45109 3.40768 0.943552C3.30481 0.656032 3.11691 0.418516 2.95368 0.252672C2.85845 0.155165 2.93157 -0.00567934 3.07015 0.000154391C3.90845 0.0368235 5.26707 0.265172 5.84436 1.68527C6.09772 2.30864 6.11642 2.95286 5.99569 3.6079C5.91918 4.02626 5.64711 4.95632 6.26776 5.0705C6.71071 5.15217 6.92496 4.80715 7.02104 4.5588C7.061 4.45546 7.19958 4.42962 7.2744 4.51213C8.02257 5.34635 8.08634 6.32892 7.9316 7.17481C7.63233 8.80992 5.94298 10 4.26469 10C2.16809 10 0.499146 8.82409 0.0663935 6.69561C-0.107898 5.83638 -0.0194766 4.13627 1.33234 2.93619C1.43267 2.84618 1.59676 2.92619 1.58315 3.0612Z",
    fill: "url(#paint0_radial_4976_7849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4976_7849",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.84943 10.0259) rotate(-179.756) scale(6.00137 9.65235)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#F44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFire);
export default __webpack_public_path__ + "static/media/ic_fire.056678170a6ed74cafa16961ccedf7bc.svg";
export { ForwardRef as ReactComponent };